module.exports = __webpack_public_path__ + "static/media/Maze_1920x1080.92480583.png";